export default __webpack_public_path__ + "static/media/aunty4.9ea5275e.png";